// extracted by mini-css-extract-plugin
module.exports = {"block":"DetailedTable_block__IXgPg","primitive":"DetailedTable_primitive__vXTMb","tableWrap":"DetailedTable_table-wrap__GLYiN"};